import { BuildingType, ZoneType } from '../../../types';
import type { Grid } from '../../../types';
import { GRID_SIZE, BUILDINGS } from '../../../constants';
import type { ZoneViolationResult } from '../types/tickResult';

/** Detect zone adjacency violations and internet-without-WAF critical alerts */
export function checkZoneViolations(grid: Grid): ZoneViolationResult {
  const violations: string[] = [];
  let threatPenalty = 0;
  const violationTiles: { x: number; y: number }[] = [];

  const directions = [
    [0, 1],
    [0, -1],
    [1, 0],
    [-1, 0],
  ];

  grid.flat().forEach((tile) => {
    if (tile.buildingType === BuildingType.None) return;
    const config = BUILDINGS[tile.buildingType];

    if (config.zone === ZoneType.Public) {
      for (const [dx, dy] of directions) {
        const nx = tile.x + dx;
        const ny = tile.y + dy;
        if (nx >= 0 && nx < GRID_SIZE && ny >= 0 && ny < GRID_SIZE) {
          const neighbor = grid[ny][nx];
          const nConfig = BUILDINGS[neighbor.buildingType];
          if (nConfig && nConfig.zone === ZoneType.Restricted) {
            const msg = `Violation: Public ${config.name} touches Restricted ${nConfig.name}`;
            if (!violations.includes(msg)) violations.push(msg);
            threatPenalty += 3;
            violationTiles.push({ x: tile.x, y: tile.y });
            violationTiles.push({ x: nx, y: ny });
          }
        }
      }
    }
  });

  const hasInternet = grid.flat().some((t) => t.buildingType === BuildingType.Internet && t.isConnected);
  const hasRestricted = grid
    .flat()
    .some((t) => BUILDINGS[t.buildingType].zone === ZoneType.Restricted && t.isConnected);
  const hasWAF = grid.flat().some((t) => t.buildingType === BuildingType.WAF && t.isConnected);

  if (hasInternet && hasRestricted && !hasWAF) {
    violations.push('Critical: Internet connected to Restricted Zone without WAF.');
    threatPenalty += 5;
  }

  const uniqueTiles = Array.from(new Set(violationTiles.map((t) => `${t.x},${t.y}`))).map((s) => {
    const [x, y] = s.split(',').map(Number);
    return { x, y };
  });

  return { violations, threatPenalty, violationTiles: uniqueTiles };
}